exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n    transition: opacity .5s\n}\n.fade-enter,\n.fade-leave-active {\n    opacity: 0\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/happypack/loader.js?id=css!./~/vue-loader/lib/style-compiler?{"id":"data-v-942cbac8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tab/tabpage.vue
// module id = 523
// module chunks = 23